import React, { useState } from "react";
import PackagesTab from "./settings/PackagesTab";
import PaymentMethodsTab from "./settings/PaymentMethodsTab";

const TABS = [
  { key: "packages", label: "الحزم" },
  { key: "payment-methods", label: "طرق الدفع" },
];

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState("packages");
  const dir = "rtl";

  return (
    <div className="p-8" dir={dir}>
      <h1 className="text-2xl font-bold mb-6">الإعدادات</h1>
      <div className="flex gap-4 border-b mb-6">
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={`px-4 py-2 font-semibold border-b-2 ${activeTab === tab.key ? "border-[#8C1C13] text-[#8C1C13]" : "border-transparent text-gray-600"}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>
        {activeTab === "packages" && <PackagesTab />}
        {activeTab === "payment-methods" && <PaymentMethodsTab />}
      </div>
    </div>
  );
}
